import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "panel-empty"
};
var _hoisted_2 = ["src"];
import { computed } from 'vue';

/* 变量 */

export default {
  __name: 'Empty',
  props: {
    name: {
      type: String,
      default: ''
    }
  },
  setup: function setup(__props) {
    /* 工具 */
    var props = __props;

    /* 计算属性 */
    var emptyImg = computed(function () {
      return require("@/assets/discuss/empty.png");
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("img", {
        src: emptyImg.value,
        alt: ""
      }, null, 8, _hoisted_2), _cache[0] || (_cache[0] = _createTextVNode(" 暂无数据 ", -1))]);
    };
  }
};